import { forwardRef, type InputHTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface ControlProps extends InputHTMLAttributes<HTMLInputElement> {}

export const Control = forwardRef<HTMLInputElement, ControlProps>(
  ({ className, ...rest }, ref) => {
    return (
      <input
        {...rest}
        ref={ref}
        className={twMerge(
          'flex-1 border-0 bg-transparent p-0 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:text-monochromatic-400',
          className,
        )}
      />
    )
  },
)

Control.displayName = 'Control'
